import React from 'react';
import { AlertTriangleIcon, ClipboardListIcon, FileTextIcon, LayersIcon, NetworkIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { steps } from '../../data/content';
const icons = {
  capture: ClipboardListIcon,
  classify: LayersIcon,
  flag: AlertTriangleIcon,
  document: FileTextIcon,
  escalate: NetworkIcon
} as const;
export function Framework() {
  return <section className="w-full bg-navy-800 px-4 py-14 text-white sm:py-20" aria-labelledby="framework-title" data-id="element-174" data-mp="1z6tu1mdye9z4">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="241hnlzntdukk">
        <p className="mb-3 text-center text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-176" data-mp="1q91hgpzm9gff">
          A 5-step professional assessment framework
        </p>
        <SectionHeading id="framework-title" dark lead="A structured system designed to help qualified clinicians move from initial observations to organized documentation and appropriate escalation." data-id="element-177" data-mp="1ga2ftrd9ql1x">
          Introducing the <span className="text-accent-400" data-id="element-178" data-mp="2yybfirncdfje">Laser Complication Decision Map™</span>
        </SectionHeading>

        <ol className="relative mt-10 space-y-5" data-id="element-179" data-mp="2u0jcp2l5s90f">
          {steps.map((step, i) => {
          const Icon = icons[step.key as keyof typeof icons];
          return <li key={step.key} className="relative flex gap-4" data-id="element-180" data-mp="33xxr6wniunq3" data-mpi={i}>
                <div className="flex flex-col items-center" data-id="element-181" data-mp="33ypbhbbo4z12">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-accent-500 text-navy-950" data-id="element-182" data-mp="2g7jv8v1tg4q8">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-183" data-mp="2batgqc5nth6x" />
                  </span>
                  {i < steps.length - 1 && <span className="mt-2 w-0.5 flex-1 bg-accent-500/40" aria-hidden="true" data-id="element-184" data-mp="2p2rmqe42qwyv" />}
                </div>
                <div className="flex-1 rounded-2xl bg-navy-900 p-5 ring-1 ring-white/10" data-id="element-185" data-mp="1wkcit2s8h9es">
                  <p className="text-xs font-bold uppercase tracking-wide text-gold-400" data-id="element-186" data-mp="1whzr3xwobkoj">Step {i + 1}</p>
                  <h3 className="mt-1 font-display text-xl font-black uppercase sm:text-2xl" data-id="element-187" data-mp="1sgxyw116c8w2">{step.title}</h3>
                  <p className="mt-2 font-semibold text-white" data-id="element-188" data-mp="gy1dzk2wlz2">{step.subtitle}</p>
                  <p className="mt-2 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-189" data-mp="ev0ullavag3">{step.body}</p>
                  <p className="mt-4 rounded-xl bg-accent-500/15 px-3 py-2 text-sm text-accent-300" data-id="element-190" data-mp="5aafvgv1nce3">
                    <strong className="text-white" data-id="element-191" data-mp="38oo87urwi18j">Your output:</strong> {step.output}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-10 text-center font-display text-lg font-black uppercase leading-snug sm:text-2xl" data-id="element-192" data-mp="3dpu4g2krs6mt">
          One framework. Five steps. <span className="text-gold-400" data-id="element-193" data-mp="3nmgncltjcnm7">A clearer professional workflow.</span>
        </p>

        <SectionCTA label="Get instant access for $27" dark data-id="element-194" data-mp="xwvcowuaggp1" />
      </div>
    </section>;
}